export default __webpack_public_path__ + "static/every-drop-count-banner-7352310757ab4f64da983fdfbdaf1513.png";